// extracted by mini-css-extract-plugin
export default {"root":"PlaygroundChatInput-module__root--H9Sz2"};